
import { defineComponent, provide } from "vue";
import store from "@/store";
import Navbar from "./components/Navbar.vue";

export default defineComponent({
  components: {
    Navbar,
  },
  setup() {
    provide("store", store);
  },
});
